import { render, staticRenderFns } from "./open-lhc.vue?vue&type=template&id=45ecd504&"
import script from "./open-lhc.vue?vue&type=script&lang=js&"
export * from "./open-lhc.vue?vue&type=script&lang=js&"
import style0 from "./open-lhc.vue?vue&type=style&index=0&id=45ecd504&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports